var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhiteRedBenchmark13983B35(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Benchmark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.478,
    y: 314.797,
    style: {
      fill: "#FFFFFF"
    },
    width: 287.236,
    height: 9.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.904,294.126H94.67V198.26h63.234V294.126z M103.873,284.924h44.828v-77.461h-44.828V284.924 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.904,294.126h-63.23V174.623h63.23V294.126z M157.877,284.924h44.824V183.826h-44.824 V284.924z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.522,294.126h-63.234V186.967h63.234V294.126z M211.49,284.924h44.828V196.17H211.49V284.924 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DD0014"
    },
    points: "179.379,157.125 155.096,117.748 162.932,112.922 179.577,139.915 215.445,84.621  223.165,89.627  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.858,
    y: 225.563,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.937,
    height: 9.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.155,
    y: 225.563,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.937,
    height: 9.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.557,
    y: 225.563,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.937,
    height: 9.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.729,
    y: 225.563,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.937,
    height: 9.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.9,
    y: 225.563,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.937,
    height: 9.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 284.921,
    y: 225.563,
    style: {
      fill: "#FFFFFF"
    },
    width: 38.937,
    height: 9.203
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhiteRedBenchmark13983B35);
export default __webpack_public_path__ + "static/media/icon-white-red-Benchmark.13983b35.2f0240f709e4905745855d91acc13e1e.svg";
export { ForwardRef as ReactComponent };